<template>
    <div class="content" style="background-color:#051a4b;overflow: auto" id="fullDiv">
        <div class="flex-container" style="background-color:#051a4b;" >
            <div class="office-efficiency-index" style="background-color:#051a4b;background-size:cover">
                <div class="office-header">

                    <div class="title-info">MRO大屏</div>
                    <span style="color:#fffff0;font-size:12px;padding-left:8px" >{{minute}}</span>
                </div>
            </div>
            <div style="width:100%;text-align:right;margin-right:100px">
                <FullScreenButton :div-id={divId} @reDrawChart="reDrawChart" ></FullScreenButton>
            </div>
            <!--            <FullScreenButton targetRef={targenRef}-->
            <!--                              fullBack={(f:boolean) => {-->
            <!--            changeFull(f);-->
            <!--            }}/>-->

            <div style="min-width: 300px;">
                <el-row :gutter="8">
                    <el-col :span="7">
                <div class="cardDiv" style="width: 100%;">

                    <div class="office-header1"  >
                        <div class="title-info2">商品大类</div>
                    </div>
                    <div style="width:100%;height:550px;" ref="chartsProduct"></div>
                </div>
                    </el-col>
                    <el-col :span="10">
                <div class="cardDiv" style="width: 100%;height:580px; position: relative; display: flex; align-items: center; justify-content: center;">
                    <div style="width: 150px;min-width: 150px; position: absolute; transform: translate(-140px, -150px); border: 0;border-radius: 0;font-size:17px;background: linear-gradient(to left, #6190e8, rgb(5, 26, 75)); color: #fff; text-align:center;padding: 5px">
                        <div style="width: 100%;"><i class="el-icon-user" style="margin-right:3px"></i>{{userCount}}人</div>
                        <div class="tip" style="width: 100%;">注册用户数</div>
                    </div>
                    <div style="width: 150px;min-width: 150px; position: absolute; transform: translate(-220px, 0); border: 0;border-radius: 0;font-size:17px;background: linear-gradient(to left, #6190e8, rgb(5, 26, 75)); color: #fff; text-align:center;padding: 5px">
                        <div><i class="el-icon-user" style="margin-right:3px"></i>{{customerCount}}家</div>
                        <div class="tip">客户数</div>
                    </div>
                    <div style="width: 150px;min-width: 150px; position: absolute; transform: translate(-140px, 150px); border: 0;border-radius: 0;font-size:17px;background: linear-gradient(to left, #6190e8, rgb(5, 26, 75)); color: #fff; text-align:center;padding: 5px">
                        <div><i class="el-icon-user" style="margin-right:5px"></i>{{supplierCount}}家</div>
                        <div class="tip">供应商数</div>
                    </div>
                    <div style="width:250px; height: 250px; position: absolute; border: 0;border-radius: 50%;background: radial-gradient(circle at center, #6190e8 0%, rgb(5, 26, 75) 100%); color: #fff; padding: 5px; text-align: center;">
                        <div style="font-size: 24px; margin-top: 100px;"><i class="el-icon-money" style="margin-right: 5px;"></i>{{formatterMoney(orderPrice)}}元</div>
                        <div class="tip" style="margin-top: 5px;">销售额(GVM)</div>
                    </div>
                    <div style="width: 150px;min-width: 150px; position: absolute; transform: translate(140px, -150px); border: 0;border-radius: 0;font-size:17px;background: linear-gradient(to right, #6190e8, rgb(5, 26, 75)); color: #fff; text-align:center;padding: 5px">
                        <div><i class="el-icon-notebook-1" style="margin-right:5px"></i>{{categoryCount}}种</div>
                        <div class="tip">商品分类</div>
                    </div>
                    <div style="width: 150px;min-width: 150px; position: absolute; transform: translate(220px, 0); border: 0;border-radius: 0;font-size:17px;background: linear-gradient(to right, #6190e8, rgb(5, 26, 75)); color: #fff; text-align:center;padding: 5px">
                        <div><i class="el-icon-goods" style="margin-right:3px"></i>{{productCountPublish}}个</div>
                        <div class="tip">商品数量</div>
                    </div>
                    <div style="width: 150px;min-width: 150px; position: absolute; transform: translate(140px, 150px); border: 0;border-radius: 0;font-size:17px;background: linear-gradient(to right, #6190e8, rgb(5, 26, 75)); color: #fff; text-align:center;padding: 5px">
                        <div><i class="el-icon-shopping-cart-full" style="margin-right:3px"></i>{{saleorderCount}}个</div>
                        <div class="tip">订单总数</div>
                    </div>
                     </div>
                    </el-col>
                    <el-col :span="7">
                        <div class="cardDiv"  style="width: 100%;">
                            <div class="office-header1"  >
                                <div class="title-info2">核心客户TOP5</div>
                            </div>
                            <div style="width:100%;height:550px;" ref="chartsCustomerMain"></div>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="8">
                    <el-col :span="7">
                        <div class="cardDiv"  style="width: 100%;">
                            <div class="office-header1"  >
                                <div class="title-info2">品牌</div>
                            </div>
                            <div style="width:100%;height:550px;" ref="chartsBrand"></div>
                        </div>

                    </el-col>
                    <el-col :span="10">
                        <div class="cardDiv" style="width: 100%;">

                            <div class="office-header3"  >
                                <div class="title-info2">配送区域及频次</div>
                            </div>
                            <div style="width:100%;height:550px;" ref="chartsMap"></div>
                        </div>
                    </el-col>
                    <el-col :span="7">
                        <div class="cardDiv"  style="width: 100%;">
                            <div class="office-header1"  >
                                <div class="title-info2">供应商供货情况</div>
                            </div>
                            <div style="width:100%;height:550px;" ref="chartsSupplierPro"></div>
                        </div>

                    </el-col>
                    <!--                <el-col :span="4">-->
                    <!--                    <el-card class="box-card" shadow="hover" style="width:100%" body-style="font-size:20px;background: linear-gradient(to right, #06beb6, #028ea1); color: #fff; text-align:center;">-->
                    <!--                        <div><i class="el-icon-shopping-cart-full" style="margin-right:5px"></i>{{rfqCount}} 单</div>-->
                    <!--                        <div class="tip">预询价单数</div>-->
                    <!--                    </el-card>-->
                    <!--                </el-col>-->
                    <!--                <el-col :span="4">-->
                    <!--                    <el-card class="box-card" shadow="hover" style="width:100%" body-style="font-size:20px;background: linear-gradient(to right, #028ea1, #06beb6); color: #fff; text-align:center;">-->
                    <!--                        <div><i class="el-icon-document-checked" style="margin-right:5px"></i>{{dealRateCount}}%</div>-->
                    <!--                        <div class="tip">成单率</div>-->
                    <!--                    </el-card>-->
                    <!--                </el-col>-->
                    <!--                <el-col :span="4">-->
                    <!--                    <el-card class="box-card" shadow="hover" style="width:100%" body-style="font-size:20px;background: linear-gradient(to right, #6190e8, #a7bfe8); color: #fff; text-align:center;">-->
                    <!--                        <div><i class="el-icon-timer" style="margin-right:5px"></i>{{supplierResponseTime}} 天</div>-->
                    <!--                        <div class="tip">供应商响应时效</div>-->
                    <!--                    </el-card>-->
                    <!--                </el-col>-->
                    <!--                <el-col :span="4">-->
                    <!--                    <el-card class="box-card" shadow="hover" style="width:100%" body-style="font-size:20px;background: linear-gradient(to right, #bb73df, #ff8ddb); color: #fff; text-align:center;">-->
                    <!--                        <div><i class="el-icon-truck" style="margin-right:5px"></i>{{deliveryCycle}} 天</div>-->
                    <!--                        <div class="tip">发货周期</div>-->
                    <!--                    </el-card>-->
                    <!--                </el-col>-->
                </el-row>

                <el-row :gutter="20" style="margin-top:20px">
<!--                    <el-col :span="24">-->

<!--                    </el-col>-->
<!--                    <el-col :span="24" style="margin-top:10px">-->
<!--                        <div class="cardDiv"  style="width: 100%;">-->
<!--                            <div class="office-header3"  >-->
<!--                                <div class="title-info2">商品分类总览</div>-->
<!--                            </div>-->
<!--                            <div style="width:100%;height:500px;" ref="chartsProCat"></div>-->
<!--                        </div>-->
<!--                    </el-col>-->
                    <el-col :span="6">
                        <div class="cardDiv"  style="width: 100%;">
                            <div class="office-header1"  >
                                <div class="title-info2">热门浏览产品</div>
                            </div>
                            <div style="width:100%;height:400px;" ref="chartsProductHot"></div>
                        </div>

                    </el-col>
                    <el-col :span="6">
                        <div class="cardDiv"  style="width: 100%;">
                            <div class="office-header1"  >
                                <div class="title-info2">热门销售产品</div>
                            </div>
                            <div style="width:100%;height:400px;" ref="chartsSale"></div>
                        </div>

                    </el-col>
                    <el-col :span="6">
                        <div class="cardDiv"  style="width: 100%;">
                            <div class="office-header1"  >
                                <div class="title-info2">热门搜索产品</div>
                            </div>
                            <div style="width:100%;height:400px;" ref="chartsSearch"></div>
                        </div>

                    </el-col>

<!--                    <el-col :span="12">-->
<!--                        <div class="cardDiv"  style="width: 100%;">-->
<!--                            <div class="office-header1"  >-->
<!--                                <div class="title-info2">合作供应商</div>-->
<!--                            </div>-->
<!--                            <div style="width:100%;height:400px;" ref="chartsSupplier"></div>-->
<!--                        </div>-->

<!--                    </el-col>-->


                    <el-col :span="6">
                        <div class="cardDiv"  style="width: 100%;">
                            <div class="office-header1"  >
                                <div class="title-info2">订单情况</div>
                            </div>
                            <div style="width:100%;height:400px;" ref="chartsOrder"></div>
                        </div>

                    </el-col>

                    <!--                <el-col :span="12">-->
                    <!--                    <el-card class="box-card" shadow="hover" style="width: 100%">-->
                    <!--                        <div slot="header" class="clearfix">-->
                    <!--                            <span>热门销售产品</span>-->
                    <!--                        </div>-->
                    <!--                        <div style="width:100%;height:300px;" ref="chartsSale"></div>-->
                    <!--                    </el-card>-->
                    <!--                </el-col>-->
                    <!--                <el-col :span="12">-->
                    <!--                    <el-card class="box-card" shadow="hover" style="width: 100%">-->
                    <!--                        <div slot="header" class="clearfix">-->
                    <!--                            <span>热门搜索产品</span>-->
                    <!--                        </div>-->
                    <!--                        <div style="width:100%;height:300px;" ref="chartsSearch"></div>-->
                    <!--                    </el-card>-->
                    <!--                </el-col>-->
                    <!--                <el-col :span="12">-->
                    <!--                    <el-card class="box-card" shadow="hover" style="width: 100%">-->
                    <!--                        <div slot="header" class="clearfix">-->
                    <!--                            <span>品牌</span>-->
                    <!--                        </div>-->
                    <!--                        <div style="width:100%;height:300px;" ref="chartsBrand"></div>-->
                    <!--                    </el-card>-->
                    <!--                </el-col>-->
                    <!--                <el-col :span="12">-->
                    <!--                    <el-card class="box-card" shadow="hover" style="width: 100%">-->
                    <!--                        <div slot="header" class="clearfix">-->
                    <!--                            <span>合作供应商</span>-->
                    <!--                        </div>-->
                    <!--                        <div style="width:100%;height:300px;" ref="chartsSupplier"></div>-->
                    <!--                    </el-card>-->
                    <!--                </el-col>-->
                    <!--                <el-col :span="12">-->
                    <!--                    <el-card class="box-card" shadow="hover" style="width: 100%">-->
                    <!--                        <div slot="header" class="clearfix">-->
                    <!--                            <span>供应商供货情况</span>-->
                    <!--                        </div>-->
                    <!--                        <div style="width:100%;height:300px;" ref="chartsSupplierPro"></div>-->
                    <!--                    </el-card>-->
                    <!--                </el-col>-->
                    <!--                <el-col :span="12">-->
                    <!--                    <el-card class="box-card" shadow="hover" style="width: 100%">-->
                    <!--                        <div slot="header" class="clearfix">-->
                    <!--                            <span>核心客户TOP5</span>-->
                    <!--                        </div>-->
                    <!--                        <div style="width:100%;height:300px;" ref="chartsCustomerMain"></div>-->
                    <!--                    </el-card>-->
                    <!--                </el-col>-->
                    <!--                <el-col :span="12">-->
                    <!--                    <el-card class="box-card" shadow="hover" style="width: 100%">-->
                    <!--                        <div slot="header" class="clearfix">-->
                    <!--                            <span>订单情况</span>-->
                    <!--                        </div>-->
                    <!--                        <div style="width:100%;height:300px;" ref="chartsOrder"></div>-->
                    <!--                    </el-card>-->
                    <!--                </el-col>-->
                    <!--                <el-col :span="12">-->
                    <!--                    <el-card class="box-card" shadow="hover" style="width: 100%">-->
                    <!--                        <div slot="header" class="clearfix">-->
                    <!--                            <span>最近7天注册用户数</span>-->
                    <!--                        </div>-->
                    <!--                        <div style="width:100%;height:300px;" ref="chartsRegister"></div>-->
                    <!--                    </el-card>-->
                    <!--                </el-col>-->
                    <!--                <el-col :span="12">-->
                    <!--                    <el-card class="box-card" style="width: 100%" shadow="hover">-->
                    <!--                        <div slot="header" class="clearfix">-->
                    <!--                            <span>最近7天日活</span>-->
                    <!--                        </div>-->
                    <!--                        <div style="width:100%;height:300px;" ref="chartsLogin"></div>-->
                    <!--                    </el-card>-->
                    <!--                </el-col>-->
                    <!--            </el-row>-->
                    <!--            <el-row :gutter="20" style="margin-top:20px">-->
                    <!--                <el-col :span="12">-->
                    <!--                    <el-card class="box-card" shadow="hover" style="width: 100%">-->
                    <!--                        <div slot="header" class="clearfix">-->
                    <!--                            <span>最近7天预询价单数</span>-->
                    <!--                        </div>-->
                    <!--                        <div style="width:100%;height:300px;" ref="chartsAsk"></div>-->
                    <!--                    </el-card>-->
                    <!--                </el-col>-->
                    <!--                <el-col :span="12">-->
                    <!--                    <el-card class="box-card" shadow="hover" style="width: 100%">-->
                    <!--                        <div slot="header" class="clearfix">-->
                    <!--                            <span>最近7天成单数</span>-->
                    <!--                        </div>-->
                    <!--                        <div style="width:100%;height:300px;" ref="chartsOrder"></div>-->
                    <!--                    </el-card>-->
                    <!--                </el-col>-->



                </el-row>
            </div>
        </div>
    </div>
</template>
<script>
    import * as echarts from 'echarts';
    import FullScreenButton from "../../components/FullScreenButton.vue";
    import geoJson from '../../../public/china';
    export default {
        components:{FullScreenButton},
        data() {
            return {
                userCount: '--',
                productCount: '--',
                rfqCount: '--',
                dealRateCount: '--',
                supplierResponseTime: '--',
                deliveryCycle: '--',
                minute: '--',
                minute2: '--',
                divId: 'fullDiv',
                saleorderCount:'--',
                orderPrice:'--',
                categoryCount:'--',
                customerCount:'--',
                supplierCount:'--',
                mapData:[]
            }
        },

        created() {

        },
        mounted() {


            let that = this;
            that.minute = that.getDateAndMinute();
            {

                echarts.registerMap('china', geoJson);
                // 要修改的数据
                let dataList = [
                    { name: '澳门', value: 0 },
                    { name: '香港', value: 0 },
                    { name: '台湾', value: 0 },
                    { name: '新疆', value: 0 },
                    { name: '宁夏', value: 2 },
                    { name: '青海', value: 3 },
                    { name: '甘肃', value: 3 },
                    { name: '陕西', value: 7 },
                    { name: '西藏', value: 0 },
                    { name: '云南', value: 5 },
                    { name: '贵州', value: 10 }, //
                    { name: '四川', value: 3 },
                    { name: '重庆', value: 4 },
                    { name: '海南', value: 1 },
                    { name: '广西', value: 1 },
                    { name: '广东', value: 2 },  //
                    { name: '湖南', value: 5 },
                    { name: '湖北', value: 6 },  //
                    { name: '河南', value: 3 },
                    { name: '山东', value: 1 },  //
                    { name: '江西', value: 1 },
                    { name: '福建', value: 1 }, //
                    { name: '安徽', value: 5 },
                    { name: '浙江', value: 6 },
                    { name: '江苏', value: 7 },  //
                    { name: '上海', value: 3 },
                    { name: '黑龙江', value: 1 },
                    { name: '吉林', value: 3 },
                    { name: '辽宁', value: 1 },  //
                    { name: '内蒙古', value: 1 },
                    { name: '山西', value: 8 },
                    { name: '河北', value: 3 },
                    { name: '天津', value: 2 },  //
                    { name: '北京', value: 927 } //
                ];
               let option = {
                    tooltip: {
                        triggerOn: "click",
                        formatter: function (e) {
                            return '.5' == e.value ? e.name + "：有疑似病例" : e.seriesName + "<br />" + e.name + "：" + e.value
                        }
                    },
                    visualMap: {

                        textStyle:{color: "#e0ffff"},
                        min: 0,
                        max: 100000,
                        left: 26,
                        bottom: 40,
                        showLabel: true,

                        text: ["高", "低"],
                        pieces: [{
                            gte: 15,
                           //label: "> 45℃",
                            color: "#4b9ee8"
                        }, {
                            gt: 15,
                            lte: 10,
                          //  label: "35 - 45℃",
                            color: "#70b7ee"
                        }, {
                            gt: 5,
                            lte: 10,
                            // label: "10 - 35℃",
                            color: "#95cff4"
                        }, {
                            gt: 0,
                            lte: 5,
                            //label: "0 - 10℃",
                            color: "#bbe7f9"
                        }, {
                            // gte: 0,
                            lte: 0,
                            // label: "<0℃",
                            color: "#e0ffff"
                        }],
                        show: true
                    },
                    geo: {
                        map: "china",
                        roam: true,
                        scaleLimit: {
                            min: 1,
                            max: 2
                        },
                        zoom: 1.13,
                        top: 50,
                        label: {
                            show: true,
                            fontSize: "14",
                            color: "rgba(0,0,0,0.7)"
                        },
                        itemStyle: {
                            borderColor: "rgba(0, 0, 0, 0.2)"
                        },
                        emphasis: {
                            areaColor: "#f2d5ad",
                            shadowOffsetX: 0,
                            shadowOffsetY: 0,
                            borderWidth: 0
                        }
                    },
                    series: [{
                        // 点击显示温度信息
                        name: "时效",
                        type: "map",
                        geoIndex: 0,
                        data: dataList
                    }]
                };
                that.chartsMap = echarts.init(that.$refs.chartsMap);
                    that.chartsMap.setOption(option);



            }



            ////  商品大类
            this.$axios.post("/admin/statistics/categoryList")
                .then(function(response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        that.chartsProduct = echarts.init(that.$refs.chartsProduct);
                        let option1 = {
                            // legend: {
                            //     orient: 'vertical',
                            //     left: 'right',
                            //     textStyle: {
                            //         color: '#ccc',
                            //         fontSize: 12
                            //
                            //     },
                            // },
                            // toolbox: {
                            //     show: true,
                            //     feature: {
                            //         mark: {show: true},
                            //         restore: {show: true},
                            //         saveAsImage: {show: true}
                            //     }
                            // },
                            tooltip: {
                                trigger: 'item'
                            },
                            series: [
                                {
                                    label: {
                                       color: '#ffffff',
                                       fontSize: 13

                                    },
                                    name: '分类',
                                    type: 'pie',
                                    radius: [50, 120],
                                    center: ['50%', '50%'],
                                    roseType: 'area',
                                    itemStyle: {
                                        borderRadius: 8
                                    },
                                    data:
                                        resp.data.map(it => {
                                            return {'name': it.key, 'value': it.value}
                                        }),

                                }
                            ]
                        };

                        that.chartsProduct.setOption(option1);
                    }
                });
            //品牌
            this.$axios.post("/admin/statistics/chartsBrand")
                .then(function(response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        that.chartsBrand = echarts.init(that.$refs.chartsBrand);
                        let optionR =   {
                            title: {
                                //text: '品牌',
                                left: 'center'
                            },
                            tooltip: {
                                trigger: 'item'
                            },
                            legend: {
                                //orient: 'vertical',
                                //left: 'left',
                                bottom: 'left',
                                textStyle: {
                                    color: '#ccc',
                                    fontSize: 12
                                }
                            },
                            //         legend: {
                            //             orient: 'vertical',
                            //             left: 'right',
                            //             textStyle: {
                            //                 color: '#ccc',
                            //                 fontSize: 12
                            //
                            //             },
                            series: [
                                {
                                    label: {
                                        color: '#ffffff',
                                        fontSize: 13

                                    },
                                    name: '访问来源',
                                    type: 'pie',
                                    radius: '50%',
                                    data:   resp.data.map(it => {
                                        return {'name': it.key, 'value': it.value}
                                    }),
                                    emphasis: {
                                        itemStyle: {
                                            shadowBlur: 10,
                                            shadowOffsetX: 0,
                                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                                        }
                                    }
                                }
                            ]
                        };
                        // 4.传入数据
                        that.chartsBrand.setOption(optionR);

                    }
                });
            // {//  商品大类
            //     that.chartsProduct = echarts.init(that.$refs.chartsProduct);
            //     let optionRegister = {
            //         legend: {
            //             orient: 'vertical',
            //             left: 'right',
            //             textStyle: {
            //                 color: '#ccc',
            //                 fontSize: 12
            //
            //             },
            //         },
            //         toolbox: {
            //             show: true,
            //             feature: {
            //                 mark: {show: true},
            //                 restore: {show: true},
            //                 saveAsImage: {show: true}
            //             }
            //         },
            //         series: [
            //             {
            //                 name: '面积模式',
            //                 type: 'pie',
            //                 radius: [50, 200],
            //                 center: ['50%', '50%'],
            //                 roseType: 'area',
            //                 itemStyle: {
            //                     borderRadius: 8
            //                 },
            //                 data: [
            //                     {value: 1548, name: '汽车精品'},
            //                     {value: 775, name: '中低压 / 工控 / 电工 / 线缆'},
            //                     {value: 629, name: '个人防护 / 安全用品'},
            //                     {value: 579, name: '工具 / 工业焊接 / 紧固密封'},
            //                     {value: 479, name: '仪器仪表 / 刀具 / 量具 / 磨具'},
            //                     {value: 879, name: '气动 / 流体机械 / 机械传动'},
            //                     {value: 679, name: '办公 / 清洁 / 制冷暖通 / 照明'},
            //                     {value: 679, name: '搬运 / 存储 / 包材 / 起重吊装'},
            //                     {value: 679, name: '胶黏 / 润滑 / 车间化学品'},
            //                     {value: 679, name: '实验室用品'},
            //                 ]
            //             }
            //         ]
            //     };
            //     // 4.传入数据
            //     that.chartsProduct.setOption(optionRegister);
            // }
            {// 商品分类总览
                // var data = {
                //     "name": "商品分类",
                //     "children": [
                //         {
                //             "name": "汽车精品",
                //             "children": [
                //                 {
                //                     "name": "车载用品",
                //                     "children": [
                //                         {"name": "Converters", "value": 721},
                //                         {"name": "DelimitedTextConverter", "value": 4294}
                //                     ]
                //                 },
                //                 {
                //                     "name": "电子产品",
                //                     "value": 3322
                //                 }
                //             ]
                //         },
                //         {
                //             "name": "中低压 / 工控 / 电工 / 线缆",
                //             "children": [
                //                 {"name": "DirtySprite", "value": 8833},
                //                 {"name": "LineSprite", "value": 1732},
                //                 {"name": "RectSprite", "value": 3623}
                //             ]
                //         },
                //         {
                //             "name": "个人防护 / 安全用品",
                //             "children": [
                //                 {"name": "FlareVis", "value": 4116}
                //             ]
                //         },
                //         {
                //             "name": "工具 / 工业焊接 / 紧固密封",
                //             "children": [
                //                 {"name": "AggregateExpression", "value": 1616},
                //                 {"name": "And", "value": 1027},
                //                 {"name": "Arithmetic", "value": 3891},
                //                 {"name": "Average", "value": 891},
                //                 {"name": "BinaryExpression", "value": 2893},
                //                 {"name": "Comparison", "value": 5103},
                //                 {"name": "CompositeExpression", "value": 3677},
                //                 {"name": "Count", "value": 781},
                //                 {"name": "DateUtil", "value": 4141},
                //                 {"name": "Distinct", "value": 933},
                //                 {"name": "Expression", "value": 5130},
                //                 {"name": "ExpressionIterator", "value": 3617},
                //                 {"name": "Fn", "value": 3240},
                //                 {"name": "If", "value": 2732},
                //                 {"name": "IsA", "value": 2039},
                //                 {"name": "Literal", "value": 1214},
                //                 {"name": "Match", "value": 3748},
                //                 {"name": "Maximum", "value": 843},
                //                 {
                //                     "name": "methods",
                //                     "children": [
                //                         {"name": "add", "value": 593},
                //                         {"name": "and", "value": 330},
                //                         {"name": "average", "value": 287},
                //                         {"name": "count", "value": 277},
                //                         {"name": "distinct", "value": 292},
                //                         {"name": "div", "value": 595},
                //                         {"name": "eq", "value": 594},
                //                         {"name": "fn", "value": 460},
                //                         {"name": "gt", "value": 603},
                //                         {"name": "gte", "value": 625},
                //                         {"name": "iff", "value": 748},
                //                         {"name": "isa", "value": 461},
                //                         {"name": "lt", "value": 597},
                //                         {"name": "lte", "value": 619},
                //                         {"name": "max", "value": 283},
                //                         {"name": "min", "value": 283},
                //                         {"name": "mod", "value": 591},
                //                         {"name": "mul", "value": 603},
                //                         {"name": "neq", "value": 599},
                //                         {"name": "not", "value": 386},
                //                         {"name": "or", "value": 323},
                //                         {"name": "orderby", "value": 307},
                //                         {"name": "range", "value": 772},
                //                         {"name": "select", "value": 296},
                //                         {"name": "stddev", "value": 363},
                //                         {"name": "sub", "value": 600},
                //                         {"name": "sum", "value": 280},
                //                         {"name": "update", "value": 307},
                //                         {"name": "variance", "value": 335},
                //                         {"name": "where", "value": 299},
                //                         {"name": "xor", "value": 354},
                //                         {"name": "x_x", "value": 264}
                //                     ]
                //                 },
                //                 {"name": "Minimum", "value": 843},
                //                 {"name": "Not", "value": 1554},
                //                 {"name": "Or", "value": 970},
                //                 {"name": "Query", "value": 13896},
                //                 {"name": "Range", "value": 1594},
                //                 {"name": "StringUtil", "value": 4130},
                //                 {"name": "Sum", "value": 791},
                //                 {"name": "Variable", "value": 1124},
                //                 {"name": "Variance", "value": 1876},
                //                 {"name": "Xor", "value": 1101}
                //             ]
                //         },
                //         {
                //             "name": "仪器仪表 / 刀具 / 量具 / 磨具",
                //             "children": [
                //                 {"name": "IScaleMap", "value": 2105},
                //                 {"name": "LinearScale", "value": 1316},
                //                 {"name": "LogScale", "value": 3151},
                //                 {"name": "OrdinalScale", "value": 3770},
                //                 {"name": "QuantileScale", "value": 2435},
                //                 {"name": "QuantitativeScale", "value": 4839},
                //                 {"name": "RootScale", "value": 1756},
                //                 {"name": "Scale", "value": 4268},
                //                 {"name": "ScaleType", "value": 1821},
                //                 {"name": "TimeScale", "value": 5833}
                //             ]
                //         }
                //     ]
                // };

            }

            // that.chartsProCat = echarts.init(that.$refs.chartsProCat);
            // let optionRegister = {
            //     tooltip: {
            //         trigger: 'item',
            //         triggerOn: 'mousemove'
            //     },
            //     series:[
            //         {
            //             type: 'tree',
            //             id: 0,
            //             name: 'tree1',
            //             data: [data],
            //
            //             top: '0%',
            //             left: '5%',
            //             bottom: '0%',
            //             right: '5%',
            //
            //             symbolSize: 7,
            //
            //             edgeShape: 'polyline',
            //             edgeForkPosition: '63%',
            //             initialTreeDepth: 3,
            //
            //             lineStyle: {
            //                 width: 2
            //             },
            //             label: {
            //                 backgroundColor: '#fff',
            //                 position: 'left',
            //                 verticalAlign: 'middle',
            //                 align: 'right',
            //                 fontSize: 12
            //             },
            //
            //             leaves: {
            //                 label: {
            //                     position: 'right',
            //                     verticalAlign: 'middle',
            //                     align: 'left'
            //                 }
            //             },
            //
            //             emphasis: {
            //                 focus: 'descendant'
            //             },
            //
            //             expandAndCollapse: true,
            //             animationDuration: 550,
            //             animationDurationUpdate: 750
            //         }
            //     ]
            // };
            // // 4.传入数据
            // that.chartsProCat.setOption(optionRegister);
            {//  热门浏览产品
                this.$axios.post("/admin/statistics/popularProduct", {cond:{type:"company"},page:0,size:10})
                .then(function(response) {
                    let resp = response.data;
                    if (resp.header.status === 0) {
                        that.chartsProductHot = echarts.init(that.$refs.chartsProductHot);
                        let optionRegister =  {
                            tooltip: {},
                            xAxis: {
                                type: 'category',
                                axisLabel: { interval: 0, rotate: 30 },
                                axisLine:{
                                    lineStyle:{  color: '#fffff0' }
                                },
                                data: (resp.data.content || []).map((item) => item.product),
                            },
                            yAxis: {
                                axisLine:{
                                    lineStyle:{  color: '#fffff0' }
                                }
                            },
                            series: {
                                label: {
                                    show: true,
                                },
                                type: 'bar',
                                data: (resp.data.content || []).map(function (item) {
                                    return {
                                        name: item.product,
                                        value: item.cnt
                                    }
                                }),
                            }
                        };
                        // 4.传入数据
                        that.chartsProductHot.setOption(optionRegister);
                    }
                });
            }
            {//  热门销售产品
                this.$axios.get("/admin/statistics/chartsPoplarSalePro")
                .then(function(response) {
                    let resp = response.data;
                    that.chartsSale = echarts.init(that.$refs.chartsSale);
                    if (resp.header.status === 0) {
                        let optionR =  {
                            tooltip: {},
                            xAxis: {
                                type: 'category',
                                axisLabel: { interval: 0, rotate: 30 },
                                axisLine:{
                                    lineStyle:{  color: '#fffff0' }
                                },
                                data: (resp.data || []).map((item) => item.key),
                            },
                            yAxis: {
                                axisLine:{
                                    lineStyle:{  color: '#fffff0' }
                                }
                            },
                            series: {
                                label: {
                                    show: true,
                                },
                                type: 'bar',
                                data: (resp.data || []).map(function (item) {
                                    return {
                                        name: item.key,
                                        value: item.value
                                    }
                                }),
                            }
                        };
                        // 4.传入数据
                        that.chartsSale.setOption(optionR);
                    }
                });
            }
            {//  热门搜索产品
                this.$axios.post("/admin/statistics/popularSearchCond", {cond:{category:"自由检索",type:"company"},page:0,size:10})
                .then(function(response) {
                    let resp = response.data;
                    if (resp.header.status === 0) {
                        that.chartsSearch = echarts.init(that.$refs.chartsSearch);
                        let optionR =  {
                            tooltip: {},
                            xAxis: {
                                type: 'category',
                                axisLabel: { interval: 0, rotate: 30 },
                                axisLine:{
                                    lineStyle:{  color: '#fffff0' }
                                },
                                data: (resp.data.content || []).map((item) => item.product.replace("商品搜索 : ", "")),
                            },
                            yAxis: {
                                axisLine:{
                                    lineStyle:{  color: '#fffff0' }
                                }
                            },
                            series: {
                                label: {
                                    show: true,
                                },
                                type: 'bar',
                                data: (resp.data.content || []).map(function (item) {
                                    return {
                                        name: item.product.replace("商品搜索 : ", ""),
                                        value: item.cnt
                                    }
                                }),
                            }
                        };
                        // 4.传入数据
                        that.chartsSearch.setOption(optionR);
                    }
                });
            }
            // {//  品牌
            //     that.chartsBrand = echarts.init(that.$refs.chartsBrand);
            //     let optionR =   {
            //         title: {
            //             //text: '品牌',
            //             left: 'center'
            //         },
            //         tooltip: {
            //             trigger: 'item'
            //         },
            //         legend: {
            //             //orient: 'vertical',
            //             //left: 'left',
            //             bottom: 'left',
            //             textStyle: {
            //                 color: '#ccc',
            //                 fontSize: 12
            //             }
            //         },
            //         //         legend: {
            //         //             orient: 'vertical',
            //         //             left: 'right',
            //         //             textStyle: {
            //         //                 color: '#ccc',
            //         //                 fontSize: 12
            //         //
            //         //             },
            //         series: [
            //             {
            //                 label: {
            //                     color: '#ffffff',
            //                     fontSize: 13
            //
            //                 },
            //                 name: '访问来源',
            //                 type: 'pie',
            //                 radius: '50%',
            //                 data: [
            //                     {value: 1048, name: '3M'},
            //                     {value: 735, name: '西门子'},
            //                     {value: 580, name: '公牛'},
            //                     {value: 484, name: '英格索兰'},
            //                     {value: 300, name: '霍尼威尔'},
            //                     {value: 300, name: '世达'},
            //                     {value: 300, name: '昆仑'},
            //                     {value: 300, name: '博世'},
            //                 ],
            //                 emphasis: {
            //                     itemStyle: {
            //                         shadowBlur: 10,
            //                         shadowOffsetX: 0,
            //                         shadowColor: 'rgba(0, 0, 0, 0.5)'
            //                     }
            //                 }
            //             }
            //         ]
            //     };
            //     // 4.传入数据
            //     that.chartsBrand.setOption(optionR);
            // }
            // {//  合作供应商
            //     that.chartsSupplier = echarts.init(that.$refs.chartsSupplier);
            //     let optionR =   {
            //         title: {
            //             // text: '供应商',
            //             left: 'center'
            //         },
            //         tooltip: {
            //             trigger: 'item'
            //         },
            //         legend: {
            //             orient: 'vertical',
            //             left: 'left',
            //             textStyle: {
            //                 color: '#ccc',
            //                 fontSize: 12
            //             }
            //         },
            //         series: [
            //             {
            //                 name: '访问来源',
            //                 type: 'pie',
            //                 radius: '50%',
            //                 data: [
            //                     {value: 1048, name: '西域智慧供应链（上海）股份公司'},
            //                     {value: 735, name: '科力普'},
            //                     {value: 580, name: '领先未来科技集团'},
            //                     {value: 484, name: '霍夫曼工具贸易（上海）有限公司'},
            //                     {value: 300, name: '北京安易捷有限公司'}
            //                 ],
            //                 emphasis: {
            //                     itemStyle: {
            //                         shadowBlur: 10,
            //                         shadowOffsetX: 0,
            //                         shadowColor: 'rgba(0, 0, 0, 0.5)'
            //                     }
            //                 }
            //             }
            //         ]
            //     };
            //     // 4.传入数据
            //     that.chartsSupplier.setOption(optionR);
            // }
            {//  供应商供货情况
                this.$axios.get("/admin/statistics/chartsSupplierPro")
                .then(function(response) {
                    let resp = response.data;
                    if (resp.header.status === 0) {
                        that.chartsSupplierPro = echarts.init(that.$refs.chartsSupplierPro);
                        let optionR =

                            {   tooltip: {},
                                xAxis: {
                                    type: 'category',
                                    axisLabel: { interval: 0, rotate: 30 },
                                    axisLine:{
                                        lineStyle:{  color: '#fffff0' }
                                    },
                                    data: (resp.data || []).map(item => item.key)
                                },
                                yAxis: {
                                    axisLine:{
                                        lineStyle:{  color: '#fffff0' }
                                    },
                                    type:'value'
                                },
                                series: {
                                    type: 'bar',
                                    label: {
                                        show: true,
                                        position: 'inside'
                                    },
                                    data: (resp.data || []).map(item => {
                                        return {
                                            name: item.key,
                                            value: item.value
                                        }
                                    }),
                                    datasetIndex: 1
                                }
                            };
                        // 4.传入数据
                        that.chartsSupplierPro.setOption(optionR);
                    }
                });
            }
            {//  核心客户TOP5
                that.chartsCustomerMain = echarts.init(that.$refs.chartsCustomerMain);
                let optionR = {
                    title: {
                        // text: '核心客户TOP5',

                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c}%"
                    },
                    // toolbox: {
                    //     feature: {
                    //         dataView: {readOnly: false},
                    //         restore: {},
                    //         saveAsImage: {}
                    //     }
                    // },
                    legend: {
                        data: ['展现','点击','访问','咨询','订单']
                    },

                    series: [
                        {
                            name:'核心客户TOP5',
                            type:'funnel',
                            left: '10%',
                            top: 60,
                            //x2: 80,
                            bottom: 60,
                            width: '80%',
                            // height: {totalHeight} - y - y2,
                            min: 0,
                            max: 100,
                            minSize: '0%',
                            maxSize: '100%',
                            sort: 'descending',
                            gap: 2,
                            label: {
                                show: true,
                                position: 'inside'
                            },
                            labelLine: {
                                length: 10,
                                lineStyle: {
                                    width: 1,
                                    type: 'solid'
                                }
                            },
                            itemStyle: {
                                borderColor: '#fff',
                                borderWidth: 1
                            },
                            emphasis: {
                                label: {
                                    fontSize: 20
                                }
                            },
                            data: [
                                {value: 100, name: '北京奔驰汽车有限公司'},
                                {value: 80, name: '北京中都星徽数科供应链管理有限公司'},
                                {value: 60, name: '北京鹏龙行汽车贸易有限公司'},
                                {value: 40, name: '福建奔驰汽车有限公司'},
                                {value: 20, name: '海纳川浩夫尔'},
                            ]
                        }
                    ]
                };
                // 4.传入数据
                that.chartsCustomerMain.setOption(optionR);
            }
            {//  订单情况 /api/admin/statistics/chartsOrders
                this.$axios.get("/admin/statistics/chartsOrders")
                .then(function(response) {
                    let resp = response.data;
                    if (resp.header.status === 0) {
                        that.chartsOrder = echarts.init(that.$refs.chartsOrder);
                        let optionR = {

                            legend: {
                                textStyle: {
                                    color: '#ccc',
                                    fontSize: 12
                                }
                            },
                            tooltip: {},
                            xAxis: {type: 'category',
                                axisLine:{
                                    lineStyle:{  color: '#fffff0' }
                                },
                                data: (resp.data || []).map(item => {
                                    return item.key
                                }),
                            },
                            yAxis: {
                                axisLine:{
                                    lineStyle:{  color: '#fffff0' }
                                }},
                            // Declare several bar series, each will be mapped
                            // to a column of dataset.source by default.
                            series: [
                                {
                                    type: 'bar',
                                    data: (resp.data || []).map(item => {
                                        return item.value
                                    }),
                                },
                                {
                                    type: 'bar',
                                    data: (resp.data || []).map(item => {
                                        return item.value
                                    }),
                                },

                            ]
                        };
                        // 4.传入数据
                        that.chartsOrder.setOption(optionR);
                    }
                });
            }
            this.$axios.get("/admin/statistics/userCount")
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.userCount = resp.data;
                    }
                });
            this.$axios.get("/admin/statistics/productCount")
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.productCount = resp.data;
                    }
                });

            this.$axios.get("/admin/statistics/customerCount")//客户数
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.customerCount = resp.data;
                    }
                });
            this.$axios.get("/admin/statistics/supplierCount")//供应商数
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.supplierCount = resp.data;
                    }
                });
            this.$axios.get("/admin/statistics/productCountPublish")//商品总数量(上架)
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.productCountPublish = resp.data;
                    }
                });
            this.$axios.get("/admin/statistics/saleorderCount")//订单总数（销售订单）
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.saleorderCount = resp.data;
                    }
                });
            this.$axios.get("/admin/statistics/orderPrice")//订单总金额
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.orderPrice = resp.data;
                    }
                });
            this.$axios.get("/admin/statistics/categoryCount")//商品分类总数
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.categoryCount = resp.data;
                    }
                });

            // this.$axios.get("/admin/statistics/rfqCount")
            // .then(function(response) {
            //     let resp = response.data;
            //     if(resp.header.status == 0) {
            //         that.rfqCount = resp.data;
            //     }
            // });
            // this.$axios.get("/admin/statistics/dealRateCount")
            // .then(function(response) {
            //     let resp = response.data;
            //     if(resp.header.status == 0) {
            //         that.dealRateCount = resp.data;
            //     }
            // });
            // this.$axios.get("/admin/statistics/supplierResponseTime")
            // .then(function(response) {
            //     let resp = response.data;
            //     if(resp.header.status == 0) {
            //         that.supplierResponseTime = resp.data;
            //     }
            // });
            // this.$axios.get("/admin/statistics/deliveryCycle")
            // .then(function(response) {
            //     let resp = response.data;
            //     if(resp.header.status == 0) {
            //         that.deliveryCycle = resp.data;
            //     }
            // });
            // this.$axios.post("/admin/statistics/register")
            // .then(function(response) {
            //     let resp = response.data;
            //     if(resp.header.status == 0) {
            //         that.chartsRegister = echarts.init(that.$refs.chartsRegister);
            //         let optionRegister = {
            //             tooltip: {
            //                 trigger: 'axis'
            //             },
            //             legend: {},
            //             xAxis: [
            //                 {
            //                     type: 'category',
            //                     data: resp.data.map(it => it.key),
            //                     axisPointer: {
            //                         type: 'shadow'
            //                     }
            //                 }
            //             ],
            //             yAxis: [
            //                 {
            //                     type: 'value',
            //                     alignTicks: true,
            //                     axisLabel: {
            //                         formatter: '{value} 人'
            //                     },
            //                     minInterval: 1,
            //                 },
            //             ],
            //             series: [
            //                 {
            //                     type: 'line',
            //                     tooltip: {
            //                         valueFormatter: value => value + ' 人'
            //                     },
            //                     // prettier-ignore
            //                     data: resp.data.map(it => it.value),
            //                 },
            //             ]
            //         };
            //         // 4.传入数据
            //         that.chartsRegister.setOption(optionRegister);
            //     }
            // });
            //
            // this.$axios.post("/admin/statistics/au")
            // .then(function(response) {
            //     let resp = response.data;
            //     if(resp.header.status == 0) {
            //         that.chartsLogin = echarts.init(that.$refs.chartsLogin);
            //         let optionLogin = {
            //             tooltip: {
            //                 trigger: 'axis'
            //             },
            //             legend: {},
            //             xAxis: [
            //                 {
            //                     type: 'category',
            //                     data: resp.data.map(it => it.key),
            //                     axisPointer: {
            //                         type: 'shadow'
            //                     }
            //                 }
            //             ],
            //             yAxis: [
            //                 {
            //                     type: 'value',
            //                     alignTicks: true,
            //                     axisLabel: {
            //                         formatter: '{value} 人'
            //                     },
            //                     minInterval: 1,
            //                 },
            //             ],
            //             series: [
            //                 {
            //                     type: 'line',
            //                     tooltip: {
            //                         valueFormatter: value => value + ' 人'
            //                     },
            //                     // prettier-ignore
            //                     data: resp.data.map(it => it.value),
            //                 },
            //             ]
            //         };
            //         // 4.传入数据
            //         that.chartsLogin.setOption(optionLogin);
            //     }
            // });
            //
            // this.$axios.post("/admin/statistics/ask")
            // .then(function(response) {
            //     let resp = response.data;
            //     if(resp.header.status == 0) {
            //         that.chartsAsk = echarts.init(that.$refs.chartsAsk);
            //         let optionAsk = {
            //             tooltip: {
            //                 trigger: 'axis'
            //             },
            //             legend: {},
            //             xAxis: [
            //                 {
            //                     type: 'category',
            //                     data: resp.data.map(it => it.key),
            //                     axisPointer: {
            //                         type: 'shadow'
            //                     }
            //                 }
            //             ],
            //             yAxis: [
            //                 {
            //                     type: 'value',
            //                     alignTicks: true,
            //                     axisLabel: {
            //                         formatter: '{value} 单'
            //                     },
            //                     minInterval: 1,
            //                 },
            //             ],
            //             series: [
            //                 {
            //                     type: 'line',
            //                     tooltip: {
            //                         valueFormatter: value => value + ' 单'
            //                     },
            //                     // prettier-ignore
            //                     data: resp.data.map(it => it.value),
            //                 },
            //             ]
            //         };
            //         // 4.传入数据
            //         that.chartsAsk.setOption(optionAsk);
            //
            //   }
            //});

            // this.$axios.post("/admin/statistics/order")
            // .then(function(response) {
            //     let resp = response.data;
            //     if(resp.header.status == 0) {
            //         that.chartsOrder = echarts.init(that.$refs.chartsOrder);
            //         let option = {
            //             tooltip: {
            //                 trigger: 'axis'
            //             },
            //             legend: {},
            //        sh     xAxis: [
            //                 {
            //                     type: 'category',
            //                     data: resp.data.map(it => it.key),
            //                     axisPointer: {
            //                         type: 'shadow'
            //                     }
            //                 }
            //             ],
            //             yAxis: [
            //                 {
            //                     type: 'value',
            //                     alignTicks: true,
            //                     axisLabel: {
            //                         formatter: '{value} 单'
            //                     },
            //                     minInterval: 1,
            //                 },
            //             ],
            //             series: [
            //                 {
            //                     type: 'line',
            //                     tooltip: {
            //                         valueFormatter: value => value + ' 单'
            //                     },
            //                     // prettier-ignore
            //                     data: resp.data.map(it => it.value),
            //                 },
            //             ]
            //         };
            //         // 4.传入数据
            //         that.chartsOrder.setOption(option);
            //     }
            //});
            window.addEventListener('resize', this.initChart);
        },
        methods: {
            //重绘
            reDrawChart() {
                setTimeout(() => {
                    this.initChart();
                }, 500);



            },
            initChart(){
                this.minute = this.getDateAndMinute();
                if(this.chartsMap){
                    this.chartsMap.resize();
                }
                if(this.chartsProduct){
                    this.chartsProduct.resize();
                }
                if(this.chartsProductHot){
                    this.chartsProductHot.resize();
                }
                // if(this.chartsProCat){
                //     this.chartsProCat.resize();
                // }
                if(this.chartsSale){
                    this.chartsSale.resize();
                }
                if(this.chartsSearch){
                    this.chartsSearch.resize();
                }
                if(this.chartsBrand){
                    this.chartsBrand.resize();
                }
                // if(this.chartsSupplier){
                //     this.chartsSupplier.resize();
                // }
                if(this.chartsSupplierPro){
                    this.chartsSupplierPro.resize();
                }
                if(this.chartsCustomerMain){
                    this.chartsCustomerMain.resize();
                }
                if(this.chartsOrder){
                    this.chartsOrder.resize();
                }
                // setTimeout(() => {
                //     this.$message({
                //         type: 'info',
                //         message: '。。。。全屏。。。。。。。。。。。。。。。。。。。。。。。。。。',
                //         duration: 300
                //     });
                // }, 100);

                // {//  商品大类
                //     this.chartsProduct = echarts.init(this.$refs.chartsProduct);
                //     let optionRegister = {
                //         title:this.getDateAndMinute(),
                //         legend: {
                //             orient: 'vertical',
                //             left: 'right',
                //             textStyle: {
                //                 color: '#ccc',
                //                 fontSize: 12
                //
                //             },
                //         },
                //         toolbox: {
                //             show: true,
                //             feature: {
                //                 mark: {show: true},
                //                 restore: {show: true},
                //                 saveAsImage: {show: true}
                //             }
                //         },
                //         series: [
                //             {
                //                 name: '面积模式',
                //                 type: 'pie',
                //                 radius: [50, 200],
                //                 center: ['50%', '50%'],
                //                 roseType: 'area',
                //                 itemStyle: {
                //                     borderRadius: 8
                //                 },
                //                 data: [
                //                     {value: 1548, name: '汽车精品'},
                //                     {value: 775, name: '中低压 / 工控 / 电工 / 线缆'},
                //                     {value: 629, name: '个人防护 / 安全用品'},
                //                     {value: 579, name: '工具 / 工业焊接 / 紧固密封'},
                //                     {value: 479, name: '仪器仪表 / 刀具 / 量具 / 磨具'},
                //                     {value: 879, name: '气动 / 流体机械 / 机械传动'},
                //                     {value: 679, name: '办公 / 清洁 / 制冷暖通 / 照明'},
                //                     {value: 679, name: '搬运 / 存储 / 包材 / 起重吊装'},
                //                     {value: 679, name: '胶黏 / 润滑 / 车间化学品'},
                //                     {value: 679, name: '实验室用品'},
                //                 ]
                //             }
                //         ]
                //     };
                //     // 4.传入数据
                //     this.chartsProduct.setOption(optionRegister);
                // }
            },
            getDateAndMinute(){
                let today = new Date();
                let DD = String(today.getDate()).padStart(2, '0'); // 获取日
                let MM = String(today.getMonth() + 1).padStart(2, '0'); //获取月份，1 月为 0
                let yyyy = today.getFullYear(); // 获取年

                var hours = today.getHours().toString().padStart(2, '0'); // 确保是两位数
                var minutes = today.getMinutes().toString().padStart(2, '0'); // 确保是两位数
                var seconds = today.getSeconds().toString().padStart(2, '0'); // 确保是两位数
                let todays = yyyy + '-' + MM + '-' + DD+ ' ' + hours + ':' + minutes+ ':' + seconds;
                return todays;
            },
            formatterMoney(value) {
                if(value) {
                    return this.MoneyFormat(value, "", 2);
                } else {
                    return "-";
                }
            },
        },
        beforeDestroy() {


            window.removeEventListener('resize', this.initChart);


        }
    }
</script>

<style>

    office-efficiency-index{width:100%;font-family:PingFangSC-Semibold,PingFang SC;background-color: #ff000A;background-size:cover;}
    /*大屏*/
    /*头部样式*/
    .office-header{
        height:3rem;
        background-size: cover;
        background: url('/img/header.jpg')no-repeat center center
    }
    .office-header .title-info{height: 2em;color:#FFFFF0;text-align: center;font-size: 22px;font-family:'cuhei';font-weight: 400;line-height: 3em;vertical-align: middle;}

    .office-header2{
        height:2rem;
        width:100%;

        background-size: cover;
        background: url('/img/header2.jpg')no-repeat
    }
    .cardDiv{
        margin-bottom: 25px;
        width:100%;color: #ccc;
        backgroundColor:#051a4b;

        box-shadow: inset 0 0 30px #073a77;

    }
    .cardDiv2{
        border-color:#063369;
        backgroundColor:#051a4b;
        width:99%;height:100%;color: #ccc;
        /*margin-top: 15px;*/
        box-shadow: inset 0 0 30px #073a77;
    }
    .title-info2{height: 2em;color:#FFFFF0;text-align: left;font-size: 18px;
        font-family:'cuhei';font-weight: 400;
        padding-left: 5px}
    .office-header1{
        margin-top: 0;
        height:2rem;
        background-size: cover;
        background: url('/img/h800.jpg')no-repeat left center
    }
    .office-header3{
        margin-top: 0;

        height:2rem;
        background-size: cover;
        background: url('/img/h.jpg')no-repeat left center
    }
</style>
<style scoped>
    .tip {
        color: #eee;
        font-size: 14px;
    }
</style>
